import { type SquareHole } from 'metalworks-domain'

import { GenericDimensionInput } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import { GenericDistancePropertyPage } from './GenericDistancePropertyPage'

interface Props {
  id: SquareHole['id']
}

export const SquareHolePropertyPage = (props: Props) => {
  const { id } = props

  return (
    <PropertyContainer.Group spacing="large">
      <GenericDistancePropertyPage id={id} />
      <PropertyContainer.Item title="Side Length">
        <GenericDimensionInput entityId={id} instanceName="sideLength" />
      </PropertyContainer.Item>
      <PropertyContainer.Item title="Corner Radius">
        <GenericDimensionInput entityId={id} instanceName="cornerRadius" />
      </PropertyContainer.Item>
    </PropertyContainer.Group>
  )
}
